(ns app.components.buttons.views
  (:require-macros
   [re-com.core  :refer [handler-fn]])
  (:require [app.components.buttons.styles :as styles :refer [icon-button-style large-btn
                                                              large-secondary-btn large-third-btn medium-btn medium-secondar-btn medium-third-btn
                                                              selected-folder-item small-btn small-secondary-btn small-third-btn
                                                              statistics-tab-selector-not-selected-style statistics-tab-selector-selected-style
                                                              warning-large-btn warning-large-secondary-btn warning-large-third-btn warning-medium-btn
                                                              warning-medium-secondary-btn warning-medium-third-btn warning-small-btn
                                                              warning-small-secondary-btn warning-small-third-btn xlarge-btn xlarge-secondary-btn]]
            [app.components.checkbox.views :as checkbox]
            [app.components.icons.views :refer [plus-icon]]
            [re-com.core :as re-com :refer [at h-box label]]
            [re-com.radio-button :as radio-button]))

(defn folder-item-content [{:keys [icon icon-src name]}]
  [h-box :gap "8px"
   :children [(when (some? icon) [icon {:size "24px" :src icon-src}])
              [label :label name]]
   :align :center
   :justify :center])

(defn right-icon-button [{:keys [icon name]}]
  [h-box :gap "8px"
   :children [[label :label name]
              (when (some? icon) [icon])]
   :align :center])

(def button-style-map
  {:cta {:primary {:xlarge (xlarge-btn)
                   :large  (large-btn)
                   :medium  (medium-btn)
                   :small (small-btn)}
         :secondary {:xlarge (xlarge-secondary-btn)
                     :large  (large-secondary-btn)
                     :medium  (medium-secondar-btn)
                     :small (small-secondary-btn)}
         :tertiary {:large  (large-third-btn)
                    :medium  (medium-third-btn)
                    :small (small-third-btn)}}
   :warning  {:primary {:large  (warning-large-btn)
                        :medium  (warning-medium-btn)
                        :small (warning-small-btn)}
              :secondary {:large  (warning-large-secondary-btn)
                          :medium  (warning-medium-secondary-btn)
                          :small (warning-small-secondary-btn)}
              :tertiary {:large  (warning-large-third-btn)
                         :medium  (warning-medium-third-btn)
                         :small (warning-small-third-btn)}}})

(defn button [{:keys [action type title size disable onClick icon style attr]}]
  [re-com/button
   :src at
   :label [folder-item-content {:name title :icon icon}]
   :disabled? disable
   :on-click onClick
   :style style
   :attr attr
   :class (get-in button-style-map [action type size])])



(defn menu-button [{:keys [action type title size disable onClick icon style attr icon]}]
  [re-com/button
   :src at
   :label [h-box :gap "2px"
           :children [[label :label title]
                      (when (some? icon) [icon {:size "18px" :src icon}])]
           :align :center
           :justify :center]
   :disabled? disable
   :on-click onClick
   :style style
   :attr attr
   :class (get-in button-style-map [action type size])])
(defn icon-button [{:keys [id icon onClick aria-controls aria-haspopup aria-expanded style]}]
  [:button
   {:id id
    :aria-controls aria-controls
    :aria-haspopup aria-haspopup
    :aria-expanded aria-expanded
    :on-click onClick
    :class (icon-button-style)
    :style style}
   [icon]])

(defn left-icon-button [{:keys [icon icon-src selected name onClick style]}]
  [re-com/button
   :src       (at)
   :label     [folder-item-content {:icon icon :icon-src icon-src :name name}]
   :class (if (= selected true) (selected-folder-item) (styles/folder-item))
   :on-click onClick
   :style style])

(defn folder-list-header [{:keys [name addable count onClick]}]
  [h-box
   :justify :between
   :class (styles/folder-list-header)
   :children [[h-box :gap "2px" :children [[label :label name]
                                           [label :label (str "(" count ")")]]
               :align :center]
              [icon-button {:icon plus-icon :onClick onClick}]]])

(defn folder-menu-button [{:keys [name selected icon onClick]}]
  [:button
   {:class (if (= selected true) (selected-folder-item) (styles/folder-item))
    :on-click onClick}
   [h-box :gap "8px" :children [[icon]
                                [label :label name]]
    :align :center]])

(defn checkbox-button [{:keys [action type title size disable onClick icon style attr]}]
  [checkbox/checkbox-component {:name "Select all"}])

(defn statistics-tab-selector [{:keys [title on-click is-active]}]
  [re-com/button
   :label title
   :on-click on-click
   :class (if (= is-active true) (statistics-tab-selector-selected-style) (statistics-tab-selector-not-selected-style))])
